import React from "react";
import { AiOutlineCopyrightCircle } from "react-icons/ai";

const DashboardFooter: React.FC = () => {
  return (
    <div className="flex w-[90%] py-20 flex-col md:flex-row mx-auto gap-5 md:gap-0 justify-between md:items-center ">
      <div className="flex gap-[82px] items-center">
        <p className="text-[#08080d] font-Mulish text-[12px] lg:text-[16px] font-normal leading-3 lg:leading-5">
          Terms of service
        </p>
        <p className="text-[rgb(8,8,13)] font-Mulish text-[12px] lg:text-[16px] font-normal leading-3 lg:leading-5">
          Privacy Policy
        </p>
        <p className="text-[#08080d] font-Mulish text-[12px] lg:text-[16px] font-normal leading-3 lg:leading-5">
          Tour
        </p>
      </div>
      <div className=" flex items-center justify-start md:justify-center gap-2 ">
        <AiOutlineCopyrightCircle size={20} color="#08080D" />
        <p className="text-[#08080d] font-Mulish text-[12px] lg:text-[16px] font-normal leading-3 lg:leading-5">
          2023 Ecomoto
        </p>
      </div>
    </div>
  );
};

export default DashboardFooter;
